// modals/ConfirmModal.js
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { getModalVariants, overlayVariants, buttonVariants } from '../utils/animationUtils';

const ConfirmModal = ({ show, message, onConfirm, onCancel, action }) => {
    if (!show) return null;

    const isExit = action === 'exit_app';
    const title = isExit ? '앱 종료' : '단계 이동 확인';
    const cancelLabel = isExit ? '아니오' : '취소';
    const confirmLabel = isExit ? '네' : (action === 'reject' ? '거절' : '이동');

    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[1000]"
                variants={overlayVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
            >
                <motion.div
                    className="bg-white rounded-xl max-w-sm w-full p-6"
                    variants={getModalVariants()}
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                >
                    <div className="text-center mb-6">
                        <div className="text-4xl mb-3">🤔</div>
                        <h3 className="text-xl font-bold text-gray-800 mb-3">{title}</h3>
                        <p className="text-gray-600 text-lg leading-relaxed whitespace-pre-line">
                            {message}
                        </p>
                    </div>

                    <div className="grid grid-cols-2 gap-3">
                        <motion.button
                            onClick={onCancel}
                            className="py-3 px-4 bg-gray-200 text-gray-700 rounded-xl font-bold text-lg hover:bg-gray-300"
                            variants={buttonVariants}
                            whileHover="hover"
                            whileTap="tap"
                        >
                            {cancelLabel}
                        </motion.button>
                        <motion.button
                            onClick={onConfirm}
                            className={`py-3 px-4 text-white rounded-xl font-bold text-lg ${action === 'reject'
                                ? 'bg-red-500 hover:bg-red-600'
                                : 'bg-blue-500 hover:bg-blue-600'
                                }`}
                            variants={buttonVariants}
                            whileHover="hover"
                            whileTap="tap"
                        >
                            {confirmLabel}
                        </motion.button>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default ConfirmModal;